import * as React from "react"
const GrowIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={17}
    height={17}
    fill="none"
    // {...props}
  >
    <path
      fill="#363636"
      d="M1.056 16.999 0 16.346l3.904-7.99 5.452 1.652L14.677.781l1.011.737L9.89 11.574 4.504 9.942 1.056 17Z"
    />
    <path
      fill="#363636"
      d="m15.818 6.662-.876-5.103-5.217 1.002-.204-1.335L15.901 0l1.1 6.405-1.183.257Z"
    />
  </svg>
)
export default GrowIcon
